import { createReducer } from 'reduxsauce';
import { ScansReducerType } from '../types';

import Types from './actions-types';

export const INITIAL_STATE: ScansReducerType = {
  list: [],
  pagination: {
    count: 8,
    total: 8,
    page: 1,
    filter: '',
    s: null,
  },
  isLoading: false,
  hasError: false,
  categories: [],
};

export const listRequest = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const listRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data } = action;

  return {
    ...state,
    list: Array.isArray(data) ? data : data.data,
    isLoading: false,
    hasError: false,
  };
};

export const listRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const categoriesRequest = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const categoriesRequestSuccess = (
  state = INITIAL_STATE,
  action: any
) => {
  const { data } = action;

  return {
    ...state,
    categories: data,
    isLoading: false,
    hasError: false,
  };
};

export const categoriesRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const clearStore = (state = INITIAL_STATE) => INITIAL_STATE;

export const HANDLERS = {
  [Types.SCANS_LIST_REQUEST as string]: listRequest,
  [Types.SCANS_LIST_REQUEST_SUCCESS as string]: listRequestSuccess,
  [Types.SCANS_LIST_REQUEST_ERROR as string]: listRequestError,

  [Types.SCANS_CATEGORIES_REQUEST as string]: categoriesRequest,
  [Types.SCANS_CATEGORIES_REQUEST_SUCCESS as string]: categoriesRequestSuccess,
  [Types.SCANS_CATEGORIES_REQUEST_ERROR as string]: categoriesRequestError,
};

export default createReducer(INITIAL_STATE, HANDLERS);
